
import {defineComponent, onMounted, ref, watch} from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
export default defineComponent({
  name: 'AppCookiePolicy',
  components: { FontAwesomeIcon },
  setup() {
    const LS_COOKIE_POLICY = 'CookieConsent'
    const banner = ref<HTMLElement>()
    let showPolicyBanner = ref(false)

    const checkCookiePolicy = (lsName: string): boolean => {
      const policyStatus = localStorage.getItem(lsName)
      let showPolicy = false

      if (policyStatus == null) {
        localStorage.setItem(lsName, 'true')
        document.body.classList.add('cookie-banner-active')
        showPolicy = true
      }

      return showPolicy
    }

    const closeBanner = (): void => {
      showPolicyBanner.value = false
      document.body.classList.remove('cookie-banner-active')
      adjustChatButtonPosition(false)
    }

    const adjustChatButtonPosition = (isActive: boolean): void => {
      const applyStyles = (): void => {
        const chatButton = document.querySelector('iframe#ada-button-frame') as HTMLElement
        if (chatButton) {
          chatButton.style.bottom = isActive || document.location.pathname === '/user/new' ? '10%' : '0'
          chatButton.style.right = '-15px'
        }
      }

      // Retry mechanism - checks for chat btn since it may not be present immediately (coming from 3rd party)
      const retryInterval = setInterval(() => {
        const chatButton = document.querySelector('iframe#ada-button-frame') as HTMLElement
        if (chatButton) {
          applyStyles()
          clearInterval(retryInterval)
        }
      }, 200) // Retry every 200ms

      // stop retrying after 3 seconds - everything should be loaded by then
      setTimeout(() => clearInterval(retryInterval), 3000)
    }

    onMounted((): void => {
      showPolicyBanner.value = checkCookiePolicy(LS_COOKIE_POLICY)
      adjustChatButtonPosition(showPolicyBanner.value)
    })

    watch(showPolicyBanner, (newValue) => {
      adjustChatButtonPosition(newValue)
    })
    

    return {
      LS_COOKIE_POLICY,
      banner,
      showPolicyBanner,
      closeBanner,
    }
  },
})
